import { render, staticRenderFns } from "./tabbed-editor.component.vue?vue&type=template&id=01844c68&scoped=true&"
import script from "./tabbed-editor.component.vue?vue&type=script&lang=js&"
export * from "./tabbed-editor.component.vue?vue&type=script&lang=js&"
import style0 from "./tabbed-editor.component.vue?vue&type=style&index=0&id=01844c68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01844c68",
  null
  
)

export default component.exports